// frontend/packs/resources-show.js

/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order
import { featureEnabled } from 'lib/helpers';

/* main */
import 'components/resources/show/resource-show-main/resource-show-main';
import 'components/resources/show/resource-show-main-col/resource-show-main-col';

import ResourceShowMainController from 'components/resources/show/resource-show-main/resource-show-main-controller';
EezyStimulusApplication.register('resource-show-main', ResourceShowMainController);

import './resource-show-imports/resource-preview';

import './resource-show-imports/related';

import './resource-show-imports/sidebar';

import './resource-show-imports/downloads';

import './resource-show-imports/licensing';

if (featureEnabled('custom-design-service')) {
  import(
    /* webpackChunkName: 'custom-design-service-controller' */
    'components/resources/show/resource-show-details/custom-design-service-controller'
  ).then(({ default: CustomDesignServiceController }) => {
    EezyStimulusApplication.register('custom-design-service', CustomDesignServiceController);
  });
}
